document.addEventListener('DOMContentLoaded', function () {
  const catalogBtn = document.querySelector('.b-h__btn_catalog');
  const catalog = document.querySelector('.b-header-catalog');
  const catalogInside = document.querySelector('.b-header-catalog__inside');
  const closeBtn = document.querySelector('.b-header-catalog__close-btn');
  const menuItemsSelector = '.b-header-catalog__menu-item';

  if (!catalogBtn || !catalog || !catalogInside) return;

  // =========================
  // OPEN / CLOSE
  // =========================

  catalogBtn.addEventListener('click', function () {
    if (catalog.classList.contains('b-header-catalog_opened')) {
      closeCatalog();
    } else {
      openCatalog();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeCatalog);
  }

  function openCatalog() {
    catalogBtn.classList.add('b-h__btn_catalog_active');
    catalog.classList.add('b-header-catalog_opened');
    document.body.style.overflow = 'hidden';

    const menuItems = document.querySelectorAll(menuItemsSelector);

    const hasActiveElement = Array.from(menuItems).find((item) => item.classList.contains('b-header-catalog__menu-item_selected'));
    if (window.innerWidth >= 561 && menuItems.length && hasActiveElement === undefined) {
      menuItems[0].classList.add('b-header-catalog__menu-item_selected');
    }
  }

  function closeCatalog() {
    catalogBtn.classList.remove('b-h__btn_catalog_active');
    catalog.classList.remove('b-header-catalog_opened');
    document.body.style.overflow = '';
    removeSelectedFromAll();
  }

  // =========================
  // CLICK OUTSIDE LOGIC
  // =========================

  document.addEventListener('click', function (e) {
    if (!catalog.classList.contains('b-header-catalog_opened')) return;

    const clickedInsideCatalog = e.target.closest('.b-header-catalog');
    const clickedInsideContent = e.target.closest('.b-header-catalog__inside');
    const clickedButton = e.target.closest('.b-h__btn_catalog');

    // Клик вообще вне каталога
    if (!clickedInsideCatalog && !clickedButton) {
      closeCatalog();
      return;
    }

    // Клик по overlay (в каталоге, но вне внутреннего блока)
    if (clickedInsideCatalog && !clickedInsideContent) {
      closeCatalog();
    }
  });

  // =========================
  // HOVER (≥561px only)
  // =========================

  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth <= 560) return;

    const item = e.target.closest(menuItemsSelector);
    if (!item) return;

    removeSelectedFromAll();
    item.classList.add('b-header-catalog__menu-item_selected');
  });

  // =========================
  // CLICK MORE
  // =========================

  document.addEventListener('click', function (e) {
    const moreBtn = e.target.closest('.b-header-catalog__more');
    if (!moreBtn) return;

    const parentItem = moreBtn.closest(menuItemsSelector);
    if (!parentItem) return;

    removeSelectedFromAll();
    parentItem.classList.add('b-header-catalog__menu-item_selected');
  });

  // =========================
  // CLICK BACK
  // =========================

  document.addEventListener('click', function (e) {
    const backBtn = e.target.closest('.b-header-catalog__menu-back');
    if (!backBtn) return;

    const parentItem = backBtn.closest(menuItemsSelector);
    if (!parentItem) return;

    parentItem.classList.remove('b-header-catalog__menu-item_selected');
  });

  // =========================
  // UTILITY
  // =========================

  function removeSelectedFromAll() {
    document.querySelectorAll(menuItemsSelector).forEach(item => {
      item.classList.remove('b-header-catalog__menu-item_selected');
    });
  }
});
